<app-status-badge [colourScheme]="badgeColourScheme" [name]="name">
  {{ ballotType }}
</app-status-badge>
